import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { DateRange, FeedbackModel, PagedList, Review } from '../interface';
import { FeedbackResourceService, SourceSystem } from '../vn-api';
import { FeedbackType } from '../enum';

@Injectable({
  providedIn: 'root'
})
export class HxFeedbackService {

  constructor(
    private api: FeedbackResourceService,
  ) { }

  getFeedbackList(params: FeedbackListParams): Promise<PagedList<FeedbackModel>> {
    return firstValueFrom(this.api.getFeedbacks(
      params.clientId,
      params.date?.from,
      params.date?.to,
      params.hasOrder,
      params.limit,
      params.orderBy,
      params.orderId,
      params.page,
      params.rating,
      params.sort as any,
      params.sources,
      params.storeId,
      params.targetUserId,
      params.types as any,
    )) as unknown as Promise<PagedList<FeedbackModel>>;
  }

  getFeedbackById(id: number): Promise<FeedbackModel> {
    return firstValueFrom(this.api.getFeedbackById(id)) as unknown as Promise<FeedbackModel>;
  }

  createFeedback(feedback: FeedbackModel): Promise<FeedbackModel> {
    return firstValueFrom(this.api.createFeedback(feedback as any)) as unknown as Promise<FeedbackModel>;
  }

  updateFeedback(id: number, feedback: FeedbackModel): Promise<FeedbackModel> {
    return firstValueFrom(this.api.updateFeedback(id, feedback as any)) as unknown as Promise<FeedbackModel>;
  }

  removeFeedback(id: number): Promise<void> {
    return firstValueFrom(this.api.removeFeedback(id));
  }

  saveReply(id: number, replyObj: { supportText?: string; supportNote?: string, reviews?: Review[], clientText?: string }) {
    return firstValueFrom(this.api.saveSupportFeedbackById(id, replyObj as any));
  }

  saveKioskFeedback(feedback: FeedbackModel): Promise<void> {
    return firstValueFrom(this.api.saveKioskFeedback(feedback as any));
  }
}

export interface FeedbackListParams {
  sources?: SourceSystem[];
  rating?: number;
  date?: DateRange;
  page: number;
  limit: number;
  clientId?: number;
  sort?: string;
  orderBy?: string;
  targetUserId?: number;
  types?: FeedbackType[];
  storeId?: number;
  hasOrder?: boolean;
  orderId?: number;
}
